import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { FaqDataAdd, FaqDataUpd, FaqStateData } from './types';

const initialState: FaqStateData = {
	data: { error: '', data: [] },
	loading: false,
	error: '',
};

export const fetchGetFaq = createAsyncThunk('api/fetchGetFaq', () => api.fetchGetFaq());
export const fetchAddFaq = createAsyncThunk('api/fetchAddFaq', ({ token, title, content, isHidden }: FaqDataAdd) =>
	api.fetchAddFaq({ token, title, content, isHidden }),
);
export const fetchUpdFaq = createAsyncThunk('api/fetchUpdFaq', ({ token, id, title, content, isHidden }: FaqDataUpd) =>
	api.fetchUpdFaq({ token, id, title, content, isHidden }),
);
export const fetchDeleteFaq = createAsyncThunk('api/fetchDeleteFaq', ({ id, token }: { id: string; token: string }) =>
	api.fetchDeleteFaq({ id, token }),
);

const faqSlice = createSlice({
	name: 'faq',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchGetFaq.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchGetFaq.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchGetFaq.rejected, (state) => {
				state.loading = false;
				state.error = 'Ошибка при загрузке';
			})
			.addCase(fetchAddFaq.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchAddFaq.fulfilled, (state) => {
				state.loading = false;
				state.error = '';
			})
			.addCase(fetchAddFaq.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка загрузки данных';
			})
			.addCase(fetchUpdFaq.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchUpdFaq.fulfilled, (state, action) => {
				state.loading = false;
				if (Array.isArray(state.data.data) && action.payload && !action.payload.error) {
					const index = state.data.data.findIndex((item) => item.id === action.payload.id);
					if (index !== -1) {
						state.data.data[index] = action.payload;
					}
				}
				state.error = '';
			})
			.addCase(fetchUpdFaq.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка загрузки данных';
			})
			.addCase(fetchDeleteFaq.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchDeleteFaq.fulfilled, (state, action) => {
				state.loading = false;
				if (Array.isArray(state.data.data) && action.payload && !action.payload.error) {
					state.data.data = state.data.data.filter((item) => item.id !== action.payload.id);
				}

				state.error = '';
			})
			.addCase(fetchDeleteFaq.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка при удалении';
			});
	},
});

export default faqSlice.reducer;
